import type { GnomuxFeature } from "@db/content";
import { resolveLocation } from "./location";
import type { GenbankFeature } from "./parse";

/** A feature ready for database insertion, without the createdAt timestamp. */
export type RawFeature = Omit<GnomuxFeature, "createdAt">;

export function transformGenbankFeature(
  genbankFeature: GenbankFeature,
  sequenceId: string,
): RawFeature {
  const resolved = resolveLocation(genbankFeature.location);
  return {
    id: crypto.randomUUID(),
    sequenceId,
    type: genbankFeature.type,
    name: genbankFeature.name,
    strand: resolved.strand,
    segments: resolved.segments,
    qualifiers: genbankFeature.qualifiers,
  };
}
